import React, { useState, useEffect } from "react";
import classes from "./privateTraining.module.css";
import Title from "../../containers/title/title";
import InputField from "../../containers/inputField/inputField";
import Coach1 from "../../../assets/images/Tareq Al-Mahasirif 1.png";
import { sixYardAxios } from '../../../sixYardAxios';
import PromptMessage from '../../containers/promptMessage/promptMessage';
import { getImageUrl } from "../../../utils/imageUrl";

function PrivateTraining(props) {
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const [coach, setCoach] = useState(null);

  const getInitialControls = () => ({
    phone: {
      elementType: "input",
      elementConfig: {
        type: "phone",
        placeholder: "07xxxxxxxx",
        options: []
      },
      value: "",
      valueName: "phone_number",
      label: parseInt(localStorage.getItem('language')) === 1 ? "Phone Number" : "رقم الهاتف"
    },
    kidsName: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Enter name" : "أدخل الاسم",
      },
      value: "",
      label: parseInt(localStorage.getItem('language')) === 1 ? "Kid's Full Name" : "الاسم الكامل للطفل"
    },
    kidsAge: {
      elementType: "input",
      elementConfig: {
        type: "number",
        placeholder: parseInt(localStorage.getItem('language')) === 1 ? "Enter age" : "أدخل العمر",
      },
      value: "",
      label: parseInt(localStorage.getItem('language')) === 1 ? "Kid's Age" : "عمر الطفل"
    }
  });

  const [controls, setControls] = useState(getInitialControls());

  useEffect(() => {
    setControls(getInitialControls());
  }, [localStorage.getItem('language')]);

  const formElementsArray = [];
  for (let key in controls) {
    formElementsArray.push({
      id: key,
      config: controls[key]
    });
  }
  const form = formElementsArray.map((formElement, i) => (
    <div key={i} className={classes.FormGroup}>
      <InputField
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={false}
        shouldValidate={false}
        touched={false}
        withRemove={false}
        label={formElement.config.label}
        changed={event => inputChangedHandler(event, formElement.id)}
      />
    </div>
  ));
  
  const inputChangedHandler = (event, controlName) => {
    const value = controlName === 'phone' ? event : event.target.value;
    const updatedControls = {
      ...controls,
      [controlName]: {
        ...controls[controlName],
        value
      }
    };
    setControls(updatedControls);
  };
  
  const clearControls = () => {
    const updatedControls = {
      ...controls
    };
    for (let key in controls) {
      updatedControls[key] = {
        ...controls[key],
        value: ""
      };
    }
    setControls(updatedControls);
  };
  
  const handleCoachSelected = (id) => {
    if (coach === id) setCoach(null);
    else setCoach(id)
  }
  
  const submitHandler = async (e) => {
    e.preventDefault();
    if (!props.isAuthenticated) props.setShowLoginForm(true)
    else {
      setError(null);
      setLoading(true);
      try {
        const formData = {
          phone: controls.phone.value.dialCode + controls.phone.value.number,
          kid_name: controls.kidsName.value,
          kid_age: controls.kidsAge.value,
          coach_id: coach
        };
        const response = await sixYardAxios.post('/academy/training/private', formData);
        if (response.data.data) {
          clearControls();
          setSuccess(response.data.data.message);
        }
      } catch (err) {
        setError(err.response?.data?.message || 
          (parseInt(localStorage.getItem('language')) === 1 
            ? 'Something went wrong. Please try again.'
            : 'حدث خطأ ما. الرجاء المحاولة مرة أخرى.'));
      } finally {
        setLoading(false);
      }
    }
  };
  return (
    <section className={classes.privateTraining}>
      <Title title={parseInt(localStorage.getItem('language')) === 1 
        ? "PRIVATE TRAINING" 
        : "التدريب الخاص"} 
      />
      <div className={classes.Container}>
        <div className={classes.DarkEffect}>
          <p className={classes.description}>
            {props.academy?.courses?.private?.description}
          </p>
          <h3 className={classes.stepTitle}>
            {parseInt(localStorage.getItem('language')) === 1 
              ? "1 - Choose your coach by clicking on his image"
              : "١ - اختر مدربك بالنقر على صورته"}
          </h3>
          <div className={classes.coachGrid}>
            {props.academy?.courses?.private?.trainers?.map((trainer) => (
              <div className={[classes.CoachContainer, trainer.id === coach && classes.CoachSelected].join(" ")}
                key={trainer.id} onClick={() => handleCoachSelected(trainer.id)}>
                <div>
                  <img className={classes.coachImage} src={coach === trainer.id ? getImageUrl(trainer.second_image) : getImageUrl(trainer.image)} alt={trainer.name} />
                </div>
                <div className={classes.Coach}>
                  <div className={classes.Name}>{trainer.name}</div>
                  {trainer.rate && <div className={classes.Rate}>{trainer.rate}</div>}
                  <div className={classes.Kite}></div>
                  <div className={classes.Kite}></div>
                </div>
              </div>
            ))}
          </div>
          <h3 className={classes.stepTitle}>
            {parseInt(localStorage.getItem('language')) === 1 
              ? "2 - Fill the information below and submit"
              : "٢ - املأ المعلومات أدناه وأرسل"}
          </h3>
          <form className={classes.form} onSubmit={(e) => submitHandler(e)}>
            <div className={classes.formGroup}>
              {form}
            </div>
            <button type="submit" className={classes.submitButton}>
              {parseInt(localStorage.getItem('language')) === 1 ? "SUBMIT" : "إرسال"}
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/b4d5bcaf1ebb966f9c466b88bc4db272a664766c03afdc1eeb10bad706c68a4a?placeholderIfAbsent=true&apiKey=55c20a0273674f7297318d8ed49e9ee9"
                alt=""
                className={classes.submitIcon}
              />
            </button>
          </form>
        </div>
      </div>
      {error && <PromptMessage 
        message={error} 
        status={parseInt(localStorage.getItem('language')) === 1 ? 'Oops' : 'عفواً'} 
        button={parseInt(localStorage.getItem('language')) === 1 ? 'CLOSE' : 'إغلاق'} 
        click={() => setError(false)} 
      />}
      {success && <PromptMessage 
        message={success} 
        status={parseInt(localStorage.getItem('language')) === 1 ? 'CONGRATULATIONS' : 'تهانينا'} 
        successMessage 
        button={parseInt(localStorage.getItem('language')) === 1 ? 'CLOSE' : 'إغلاق'} 
        click={() => setSuccess(false)} 
      />}
    </section>
  );
}

export default PrivateTraining;
